import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_CHECK } from "react-admin";

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    const BASE = (process.env.REACT_APP_BASE_URL || "").replace(/\/?$/, "/");
    const url = BASE + "admin/auth";

    const request = new Request(url, {
      method: "POST",
      body: JSON.stringify({ username, password }),
      headers: new Headers({ "Content-Type": "application/json" })
    });

    return fetch(request)
      .then(response => {
        if (response.status < 200 || response.status >= 300) {
          return Promise.reject(new Error(response.statusText || "Login failed"));
        }
        return response.json();
      })
      .then(({ token }) => {
        localStorage.setItem("token", token);
        return Promise.resolve();
      })
      .catch(err => Promise.reject(err));
  }
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem("token");
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    return localStorage.getItem("token") ? Promise.resolve() : Promise.reject();
  }
  return Promise.resolve();
};
